import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { type RestoreAccount, type SourceAccount, AccountState, type Account, Provider, CloudAccountType } from '@repo/api-gw-sdk';
import semver from 'semver';
import { getDocsUrl } from '@/docs/docsUrls';
import { getAccountProvider, getAccountState, getAccountType } from '@/utils/accounts';
import { getAccountInstalledVersion, getAccountLatestVersion, isAccountRoleMajorMinorVersionOld } from '@/utils/roles';
import { Icon } from '../shared/icon';
import { ReadMoreLink } from '../shared/readMoreLink';
interface ChangelogKeys {
  source: Parameters<typeof getDocsUrl>[0];
  restore: Parameters<typeof getDocsUrl>[0];
}
const changelogKeyMap: Partial<Record<Provider, ChangelogKeys>> = {
  [Provider.Aws]: {
    source: 'awsSourcePermissionsChangelog',
    restore: 'awsRestorePermissionsChangelog'
  },
  [Provider.Gcp]: {
    source: 'gcpSourcePermissionsChangelog',
    restore: 'gcpRestorePermissionsChangelog'
  },
  [Provider.Azure]: {
    source: 'azureSourcePermissionsChangelog',
    restore: 'azureRestorePermissionsChangelog'
  },
  [Provider.AzureEntraId]: {
    source: 'entraIdSourcePermissionsChangelog',
    restore: 'entraIdRestorePermissionsChangelog'
  }
};
export const EonRoleVersion = t0 => {
  const $ = _c(29);
  const {
    account
  } = t0;
  const accountState = getAccountState(account);
  if (accountState === AccountState.ACCOUNT_STATE_INSUFFICIENT_PERMISSIONS || accountState === AccountState.ACCOUNT_STATE_NOT_READY) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Typography>--</Typography>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== account) {
    t1 = isAccountRoleMajorMinorVersionOld(account);
    $[1] = account;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const showWarning = t1;
  let T0;
  let T1;
  let changelogUrl;
  let latestVersion;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] !== account) {
    const installedVersion = getAccountInstalledVersion(account);
    latestVersion = getAccountLatestVersion(account);
    const provider = getAccountProvider(account);
    const unrecordedVersion = provider === Provider.Microsoft365 ? "--" : "1.0.0";
    const accountTypeKey = getAccountType(account) === CloudAccountType.Source ? "source" : "restore";
    const docsKey = changelogKeyMap[provider]?.[accountTypeKey];
    let t6;
    if ($[12] !== docsKey) {
      t6 = docsKey ? getDocsUrl(docsKey) : undefined;
      $[12] = docsKey;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    changelogUrl = t6;
    T1 = Stack;
    t4 = "row";
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        alignItems: "center",
        gap: "12px"
      };
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    T0 = Typography;
    t2 = "inline-block";
    t3 = installedVersion && semver.valid(installedVersion) ? installedVersion : unrecordedVersion;
    $[3] = account;
    $[4] = T0;
    $[5] = T1;
    $[6] = changelogUrl;
    $[7] = latestVersion;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    T0 = $[4];
    T1 = $[5];
    changelogUrl = $[6];
    latestVersion = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[15] !== T0 || $[16] !== t2 || $[17] !== t3) {
    t6 = <T0 className={t2}>{t3}</T0>;
    $[15] = T0;
    $[16] = t2;
    $[17] = t3;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== changelogUrl || $[20] !== latestVersion || $[21] !== showWarning) {
    t7 = showWarning && <Tooltip disableInteractive={false} title={<Stack sx={{
      gap: "4px"
    }}><Box component="span">v{latestVersion} is available. Upgrade permissions to enable Eon's latest features.</Box>{changelogUrl && <ReadMoreLink text="Go to the changelog" href={changelogUrl} className="text-[inherit]!" />}</Stack>}><Icon iconClass="material-symbols-error-outline-rounded h-[20px] w-[20px]" /></Tooltip>;
    $[19] = changelogUrl;
    $[20] = latestVersion;
    $[21] = showWarning;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== T1 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t8 = <T1 direction={t4} sx={t5}>{t6}{t7}</T1>;
    $[23] = T1;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};